import { Autocomplete, Box, Button, Grid, TextField } from "@mui/material";
import React from "react";

const UpdateBankDetails = ({ handleCloseDialog }) => {
  return (
    <Box mt={2}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField label="Account Number" variant="outlined" fullWidth />
        </Grid>

        <Grid item xs={12}>
          <TextField label="Bank Name" variant="outlined" fullWidth />
        </Grid>

        <Grid item xs={12}>
          <TextField label="Branch" variant="outlined" fullWidth />
        </Grid>

        <Grid item xs={12}>
          <TextField label="City" variant="outlined" fullWidth />
        </Grid>

        <Grid item xs={12} container justifyContent="flex-end" spacing={1}>
          <Grid item>
            <Button
              variant="outlined"
              color="error"
              onClick={handleCloseDialog}
            >
              Cancel
            </Button>
          </Grid>
          <Grid item>
            <Button variant="contained" color="secondary" type="submit">
              Update
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default UpdateBankDetails;
